class LightSpeedAuto {
    config = {
      "method": "POST",
      "headers": {
        "Authorization": "",
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      "body":    {
      
        "Header": {
          "Authorization": {
            "OrgId": "101506",
            "ShipId": "101506"
          },
          "QuoteBack": "Quoteback001"
        },
        "Body": JSON.stringify({
          "Driver": {
            "GivenName": "GLORIA",
            "Surname": "NORTHCRAFT",
            "DOB": "19911201"
          },
          "Addresses": [{
              "AddressType": "Current",
              "Street1": "9151 NEWTON ST",
              "City": "WESTMINSTER",
              "StateCode": "CO",
              "Zip": "80031"
            }
          ]
        })
    }
    };
  
    getConfig() {
      return this.config;
    }
  }
  
  export default new LightSpeedAuto();


// WEBPACK FOOTER //
// ./src/StartQuote/config/lightSpeedAutio.js